import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });
  
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitStatus('sending');
    
    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        e.target,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (result) => {
          console.log(result.text);
          setSubmitStatus('success');
          clearState();
          setTimeout(() => setSubmitStatus(null), 5000);
        },
        (error) => {
          console.log(error.text);
          setSubmitStatus('error');
          setTimeout(() => setSubmitStatus(null), 5000);
        }
      );
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Entre em Contato</h2>
                <p>
                  Preencha o formulário abaixo para nos enviar um e-mail e
                  retornaremos o mais breve possível.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Nome"
                        required
                        onChange={handleChange}
                        value={name}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="E-mail"
                        required
                        onChange={handleChange}
                        value={email}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Mensagem"
                    required
                    onChange={handleChange}
                    value={message}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success">
                  {submitStatus === 'success' && (
                    <div className="alert alert-success">
                      Mensagem enviada com sucesso! Entraremos em contato em breve.
                    </div>
                  )}
                  {submitStatus === 'error' && (
                    <div className="alert alert-danger">
                      Erro ao enviar mensagem. Por favor, tente novamente ou entre em contato por telefone.
                    </div>
                  )}
                </div>
                <button 
                  type="submit" 
                  className="btn btn-custom btn-lg"
                  disabled={submitStatus === 'sending'}
                >
                  {submitStatus === 'sending' ? 'Enviando...' : 'Enviar Mensagem'}
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Informações de Contato</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Endereço
                </span>
                {props.data ? props.data.address : "carregando"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Telefone
                </span>{" "}
                {props.data ? props.data.phone : "carregando"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> E-mail
                </span>{" "}
                {props.data ? props.data.email : "carregando"}
              </p>
            </div>
            {/* <div className="contact-item" style={{ marginTop: '30px' }}>
              <a 
                href={props.data ? props.data.googleReviews : "/"} 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-custom"
                style={{ 
                  width: '100%', 
                  padding: '12px 20px',
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px'
                }}
              >
                <i className="fa fa-google" style={{ fontSize: '18px' }}></i>
                Avalie-nos no Google
              </a>
            </div> */}
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a 
                      href={props.data ? props.data.instagran : "/"} 
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a 
                      href={props.data ? props.data.googleReviews : "/"} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      title="Avalie-nos no Google"
                    >
                      <i className="fa fa-google"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; {new Date().getFullYear()} Eletromaq - Manutenção e Automação. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </div>
  );
};
